import type { SVGProps } from 'react';

export const PreventionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      d="M12 8.52086C12.3838 8.52109 12.6954 8.83421 12.6954 9.22033V10.8524H14.3182C14.7022 10.8526 15.0137 11.1657 15.0137 11.5519C15.0136 11.938 14.7021 12.2512 14.3182 12.2513H12.6954V13.9071C12.6954 14.2933 12.3839 14.6063 12 14.6066C11.6159 14.6066 11.3045 14.2934 11.3045 13.9071V12.2513H9.64731C9.26325 12.2513 8.95191 11.9381 8.95184 11.5519C8.95184 11.1656 9.26321 10.8524 9.64731 10.8524H11.3045V9.22033C11.3045 8.83407 11.6159 8.52086 12 8.52086Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3688 3.09728C11.8269 2.96678 12.3131 2.96746 12.7706 3.10002L19.1974 4.96161C20.2785 5.27516 21.0714 6.28726 20.9949 7.47167C20.5739 13.9889 17.3107 18.8031 12.9553 20.7961C12.4029 21.0489 11.7708 21.0679 11.204 20.8462C6.13302 18.8608 3.38555 13.4109 3.00502 7.47713C2.92894 6.28889 3.72664 5.27508 4.81342 4.96525L11.3688 3.09728ZM12.3848 4.4443C12.177 4.38415 11.9563 4.38326 11.7482 4.44248L5.19285 6.31136C4.68375 6.45647 4.36286 6.91041 4.39324 7.38697C4.75455 13.0209 7.33364 17.8291 11.7084 19.542C11.9246 19.6265 12.1671 19.62 12.3794 19.5229C16.1842 17.7818 19.2125 13.483 19.6067 7.38059C19.6373 6.90632 19.3184 6.4529 18.8116 6.30589L12.3848 4.4443Z"
      fill="currentColor"
    />
  </svg>
);
